import CreateFormateurView from "../Vue/Pages/CreateFormateurView";

const CreateFormateurController = () => {
    return (CreateFormateurView())
  }
  
  export default CreateFormateurController;